
export enum HostlerInstructionCd {
	MOVE = 'Move',
	OTHER = 'Other',
	SWAP = 'Swap'}

